import TB from '@tiger/bridge';
import { Logger } from '@tiger/logger';
import { useSWR } from '@tiger/swr';
import UI from 'stores/ui';
import { IS_TUPSDK } from 'utils/constants';

/**
 * 以下为bridge 获取用户信息【针对加盟客户】
 */
let resolveCb = function(result) {
    Logger.log(result, 'bridge-getcustomer-log');
};
let rejectCb = function(msg) {
    Logger.log(msg, 'bridge-getcustomer-msg');
};

// @ts-ignore
window.bridgeGetCustomerResolve = function(result) {
    resolveCb(result);
};

// @ts-ignore
window.bridgeGetCustomerReject = function(msg) {
    rejectCb(msg);
};

// bridge 获取数据的超时时间
const BRIDGE_API_TIMEOUT = 10 * 1000;

// 通过bridge从加盟商获取用户信息
export function useCustomerInfoFromBridge() {
    return useSWR<{ first_name: string; middle_initial?: string; last_name: string; birthday: string; id_no: string }>(
        IS_TUPSDK && 'bridge-get-customer-info',
        {
            fetcher: () => {
                return new Promise((resolve, reject) => {
                    resolveCb = resolve;

                    let timer: ReturnType<typeof setTimeout>;

                    rejectCb = msg => {
                        reject(new Error(msg));
                    };

                    if (UI.isTiger && window.TigerBridge && window.TigerBridge.getCustomerInfo) {
                        timer = setTimeout(() => {
                            rejectCb('BRIDGE_TIMEOUT');
                        }, BRIDGE_API_TIMEOUT);

                        TB.getCustomerInfo(['first_name', 'middle_initial', 'last_name', 'birthday', 'id_no'], {
                            success: function(result) {
                                // @ts-ignore
                                window.bridgeGetCustomerResolve(result);

                                if (timer) {
                                    clearTimeout(timer);
                                }
                            },
                            fail: function(msg) {
                                // @ts-ignore
                                window.bridgeGetCustomerReject(msg);

                                if (timer) {
                                    clearTimeout(timer);
                                }
                            }
                        });
                    } else {
                        rejectCb('NOT_IN_APP');
                    }
                });
            },
            immutable: true,
            shouldRetryOnError: false
        }
    );
}
